module.exports = __webpack_public_path__ + "images/developer-logo-95435c7fe7e9e640ed188a049d43f12f.jpg";